module.exports = __webpack_public_path__ + "src/assets/img/image3-reference.e039ec64.jpg";